export default "__VITE_ASSET__uF_BEteg__"